import React from 'react';
import { useGlobalReducer } from 'src/shef-global-state/shefGlobalState';
import { useUserPreferences } from 'src/user-preferences/useUserPreferences';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';
import { SearchBar } from './SearchBar';
import { DishFirstSearchProps } from './types';

export const DishFirstSearch: React.FC<DishFirstSearchProps> = ({ backgroundRef }) => {
  const { state } = useGlobalReducer();
  const { isSmallScreen } = useScreenContext();
  const [{ zipcode: cachedZipcode }] = useUserPreferences();

  const props = {
    isSmallScreen,
    timeZone: state.timeZone,
    backgroundRef,
  };

  // Without a zip, the search won't work so don't show
  if (!cachedZipcode) return null;

  return <SearchBar {...props} />;
};

export default DishFirstSearch;
